/* eslint-disable vue/no-unused-vars */
<template>
  <div>
    <a-card style="margin-bottom:1rem" class="card">
      <div slot="title">
        <a-row>
          <a-col :xs="3" :md="2" :lg="1">
            <a-button
              type="primary"
              size="small"
              icon="left"
              shape="circle"
              class="back-button"
              style="margin-right:1rem;"
              @click="backButton"
            />
          </a-col>
          <a-col :xs="21" :md="22" :lg="23">
            <a-skeleton
              v-if="loading"
              :paragraph="false"
              :avatar="false"
              :title="{ width: '90%' }"
              active
            />
            <span>
              <span>
                <h3 class="hover-title main-card-title">
                  <a-icon type="link"></a-icon> NUEVA VENTA
                </h3>
                <h5 class="btn-edit-subscription">
                  {{ paymentLink.name }}
                  <span style="font-size:smaller; color: #aaa"
                    >#{{ paymentLink.id }}</span
                  >
                </h5>
                <h6
                  v-if="
                    paymentLink.description &&
                      paymentLink.description.trim() !== ''
                  "
                  style="color:#aaa"
                >
                  {{ paymentLink.description }}
                </h6>
              </span>
            </span>
          </a-col>
        </a-row>

        <!--<a-icon @click="backButton()" type="arrow-left">Volver </a-icon>-->
      </div>

      <div :class="$style.form" v-if="paymentLinkError">
        <p :class="$style.formTitle">
          Hubo un error al cargar la subscripción. <br /><span
            style="font-size:12px"
            >Por favor, volver a intentar.</span
          >
        </p>
      </div>
      <div :class="$style.form">
        <!--<p :class="$style.formTitle">Datos del Cliente</p>-->

        <a-divider orientation="left">Datos del Cliente</a-divider>

        <customer-form ref="customerFormComponent" />

        <a-divider orientation="left">Datos de Pago</a-divider>

        <payment-form
          v-if="paymentLink.amount && paymentLink.account.publicKey"
          ref="paymentFormComponent"
          :mode="'2-step'"
          :showPrice="true"
          :showInstallments="true"
          :showSubmit="true"
          :showAgreement="false"
          :subtotal="paymentLink.amount"
          :publicKey="paymentLink.account.publicKey"
          @cardValidated="handleSubmit"
        />

        <!--
          <payment-form
            ref="paymentFormComponent"
            :mode="'2-step'"
            :showPrice="false"
            :showInstallments="false"
            :subtotal="totalAmount"
          />-->
        <!--
        <div class="form-actions">
          <a-button
            @click="handleSubmit"
            type="primary"
            html-type="submit"
            :class="$style.loginFormButton"
            :loading="submitLoader"
            size="large"
            icon="lock"
          >
            {{ paymentLink.amount }} PAGAR
          </a-button>
        </div>-->
      </div>
    </a-card>
  </div>
</template>

<script>
//import { data } from "./data.json";
import { mapActions } from "vuex";
import store from "@/store";
import Vue from "vue";
import gateway from "@/services/gateway";
import errors from "@/services/errors";
import utils from "@/services/utils";
import PaymentForm from "@/components/PaymentForm";
import CustomerForm from "@/components/CustomerForm";

export default {
  name: "paymentLinkSell", //necesita tener un name para que funcione el <keep-alive>
  components: {
    "payment-form": PaymentForm,
    "customer-form": CustomerForm
  },
  data() {
    return {
      paymentLinkId: null,
      paymentLinkError: false,
      form: this.$form.createForm(this),
      cardSelectedId: null,
      defaultCardId: null,
      loading: false,
      submitLoader: false,
      editIcon: false,
      subscriber: null,
      subscriberActive: true,
      switchDisabled: false,
      switchLoader: false,
      paymentLink: {
        id: null,
        account: {
          publicKey: null
        },
        name: null,
        description: null,
        amount: null,
        createdAt: null,
        endDate: null,
        statusId: null,
        salesCount: null,
        totalSold: null,
        totalSoldCurrentMonth: null,
        costCenter: {
          id: null,
          name: null,
          product: { name: null }
        },
        businessUnit: {
          id: null,
          name: null
        },
        product: {
          id: null,
          name: null
        }
      }
    };
  },
  //props: ["paymentLinkId"],
  methods: {
    ...mapActions({
      loadPaymentLink: "paymentLinks/loadOne",
      sell: "paymentLinks/sell"
    }),
    backButton() {
      this.$router.push(`/payment-links/${this.paymentLink.id}`);
    },
    async fetchRecord() {
      try {
        //console.log("params:", params);
        //const id = this.$router.params.id
        this.loading = true;
        this.paymentLinkId = this.$route.params.id;
        const paymentLink = await this.loadPaymentLink(this.paymentLinkId);
        const x = 10;
        if (!paymentLink) throw new Error("Error al buscar el link de pago.");
        this.paymentLink = paymentLink;
        store.state.paymentForm.subtotal = paymentLink.amount;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    async handleSubmit(paymentFormPayload) {
      this.submitLoader = true;
      let customerRes2;
      //let payload;
      //if (e) e.preventDefault();
      //const paymentFormPayload = await this.$refs.paymentFormComponent.handleSubmit();
      this.$refs.paymentFormComponent.enableSubmitLoader();
      const customerFormPayload = await this.$refs.customerFormComponent.handleSubmit();
      const x = 10;
      if (paymentFormPayload && customerFormPayload) {
        let err;
        const x = 10;
        try {
          const response = await this.sell({
            paymentFormPayload,
            customerFormPayload,
            linkToken: null,
            paymentLinkId: this.paymentLinkId
          });

          this.submitLoader = false;
          this.$refs.paymentFormComponent.disableSubmitLoaderWithSuccess();
          this.$notification["success"]({
            message: "Exito",
            description: response.message
          });
          this.backButton();
        } catch (err) {
          console.log(err);
          this.submitLoader = false;
          this.$refs.paymentFormComponent.disableSubmitLoaderWithError();
          let description;

          if (err.message) description = err.message;
          else
            description =
              "Error al realizar el pago. Por favor, intente denuevo.";

          this.$notification["warning"]({
            message: "Error",
            description: description
          });
        }
      }
    },
    cardNameHelper() {
      if (
        this.form.getFieldValue("cardName") == undefined &&
        this.form.getFieldValue("firstName") != undefined &&
        this.form.getFieldValue("lastName") != undefined
      )
        this.form.setFieldsValue({
          cardName: `${this.form.getFieldValue(
            "firstName"
          )} ${this.form.getFieldValue("lastName")}`
        });
    },
    handleRoute() {
      this.switchDisabled = true;
    }
  },
  mounted() {
    this.handleRoute();
    this.fetchRecord();
  },
  watch: {
    //REACTIVE TO URL CHANGE
    $route(to) {
      this.handleRoute();
    }
  }
};
</script>

<style lang="scss" module>
@import "./index.module.scss";
</style>

<style lang="css">
h3 {
  font-size: 1.2rem;
}
.ant-card {
  border-radius: 7px;
}
.ant-card-head-title {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 2rem;
}
.ant-card-body {
  padding-bottom: 9px;
}
.ant-form-item-control-wrapper {
  /*white-space: nowrap;*/
}
.back-button {
  /*background-color: #fff;
  border-color: #777;
  color: #777;*/
  vertical-align: 0.38rem;
}
.back-button .anticon {
  vertical-align: -0.213rem;
}
.ant-collapse-item {
  border-bottom: none !important;
}
.add-form {
  width: 30rem;
}
.tooltip-icon {
  color: #ccc;
  margin-left: 0.5rem;
}
.tooltip-top {
  position: absolute;
  top: 2px;
  right: -19px;
}
@media (max-width: 767px) {
  .ant-card-head-wrapper {
    flex-direction: column-reverse !important;
    align-items: flex-start;
  }
  .ant-card-head-title {
    flex-grow: 5;
    /*font-size: 100%;*/
    width: 25rem;
  }
  .ant-card-extra {
    float: inherit !important;
    margin-left: inherit !important;
    align-self: flex-end;
  }
  .add-form {
    width: inherit;
  }
  .ant-switch {
    margin-left: 0 !important;
  }
  .title-id {
    display: none;
  }
  .hover-title {
    font-size: 1.7rem;
    letter-spacing: -1px;
  }
  .hover-title + .edit-icon {
    display: inline;
  }
  .edit-subscription-button {
    display: inline !important;
  }
}
.edit-subscription-button {
  display: none;
}
.edit-icon {
  display: none;
}
.hover-title {
  cursor: pointer;
}
.hover-title:hover + .edit-icon {
  display: inline;
}
</style>
